const viewTypes = {
  TABLE: "Table",
  GRID: "Grid",
  KANBAN: "Kanban",
  GANTT: "Gantt",
  CALENDAR: "Calendar",
  CHART: "Chart",
};

export default viewTypes;
